import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sora2Video from "../pages/sora2-video/page";
import Veo31Video from "../pages/veo31-video/page";
import Sora2Storyboard from "../pages/sora2-storyboard/page";
import AIImage from "../pages/ai-image/page";
import OneClickVideo from "../pages/one-click-video/page";
import StyleTransfer from "../pages/style-transfer/page";
import ViralVideoReverse from "../pages/viral-video-reverse/page";
import AIChat from "../pages/ai-chat/page";
import VirtualModels from "../pages/virtual-models/page";
import CreateVirtualModel from "../pages/create-virtual-model/page";
import History from "../pages/history/page";
import Materials from "../pages/materials/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Recharge from "../pages/recharge/page";
import DatabaseManagerPage from "../pages/database-manager/page";
import { lazy } from "react";

const AdminPage = lazy(() => import("../pages/admin/page"));
const UserManagementPage = lazy(() => import("../pages/admin/users/page"));
const ModelManagementPage = lazy(() => import("../pages/admin/models/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/recharge",
    element: <Recharge />,
  },
  {
    path: "/history",
    element: <History />,
  },
  {
    path: "/materials",
    element: <Materials />,
  },
  {
    path: "/sora2-video",
    element: <Sora2Video />,
  },
  {
    path: "/veo31-video",
    element: <Veo31Video />,
  },
  {
    path: "/sora2-storyboard",
    element: <Sora2Storyboard />,
  },
  {
    path: "/ai-image",
    element: <AIImage />,
  },
  {
    path: "/style-transfer",
    element: <StyleTransfer />,
  },
  {
    path: "/viral-video-reverse",
    element: <ViralVideoReverse />,
  },
  {
    path: "/reference-images",
    element: lazy(() => import("../pages/reference-images/page")) as any,
  },
  {
    path: "/one-click-video",
    element: <OneClickVideo />,
  },
  {
    path: "/ai-chat",
    element: <AIChat />,
  },
  {
    path: "/virtual-models",
    element: <VirtualModels />,
  },
  {
    path: "/create-virtual-model",
    element: <CreateVirtualModel />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/users",
    element: <UserManagementPage />,
  },
  {
    path: "/admin/models",
    element: <ModelManagementPage />,
  },
  {
    path: "/database-manager",
    element: <DatabaseManagerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;